import { deriveD2CTextColors } from "@/scott/ui/lib/d2c-colors";
import type { UiConfiguration } from "@/types/page-block";

export interface UiConfigurationInput {
  sys?: { id: string };
  __typename: "UiConfiguration";
  internalName: string;
  backgroundColor?: "black" | "white" | "whitesmoke";
  paddingTop?: "none" | "small" | "medium" | "large";
  paddingBottom?: "none" | "small" | "medium" | "large";
}

export function UiConfigurationAdapter(
  item: UiConfigurationInput
): UiConfiguration {
  const { headlineColor, textColor } = deriveD2CTextColors(
    item.backgroundColor
  );

  return {
    backgroundColor: item.backgroundColor,
    headlineColor,
    textColor,
    paddingTop: item.paddingTop,
    paddingBottom: item.paddingBottom,
  };
}
